import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[_c(VCard,{attrs:{"rounded":"","min-height":"100vw"}},[_c('p',[_vm._v(" Dark room")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }